import type { ApiData, ArticleCategory } from '~/types/site-api'

/**
 * 站点文章分类：在默认布局中初始化，供导航与文章页面共享。
 */
export function useArticleCategories() {
  const { getArticleCategories } = useSiteApi()
  return useAsyncData<ApiData<ArticleCategory[]>>(
    'site-article-categories',
    (_nuxtApp, { signal }) => getArticleCategories(signal),
    {
      dedupe: 'defer',
      getCachedData(key, nuxtApp) {
        return nuxtApp.payload.data[key] as ApiData<ArticleCategory[]> | undefined
      },
    }
  )
}
